import cx from 'classnames';
import type { FunctionComponent, ReactNode } from 'react';

import './Filter.less';

export type FilterPanelProps = {
  title?: ReactNode | string;
};

/**
 *  Renders a Filter panel with an optional title
 *
 * @param {FilterPanelProps} props - FilterPanel props
 * @param {string} [props.title] - The panel title (if provided)
 * @param {string} props.children - The panel's children to be rendered
 * This will be replaced with an Accordion Card in the future, but for now
 * it is an acceptable way to render a filter panel.
 */
const FilterPanel: FunctionComponent<FilterPanelProps> = ({ children, title }) =>
  <div className="filter-panel">
    {title &&
      <header className="filter-panel__header">
        <legend className="filter-panel__header__main-title">
          {title}
        </legend>
      </header>}
    <section className={cx('filter-panel__body', {
      'filter-panel__body--has-header': !!title,
    })}>
      {children}
    </section>
  </div>;

export default FilterPanel;
